import {
  LOAD_HOME_CONTENT_FULFILLED,
  LOAD_HOME_SERVICES_FULFILLED,
  LOAD_HOME_REVIEW_FULFILLED
} from "../actions/types";

const initialState = {
  loadingScrollerImages: true,
  scrollerImages: [],
  loadingServices: true,
  services: [],
  loadingFeedback: true,
  feedback: {}
};

export default function(state = initialState, action) {
  switch (action.type) {
    case LOAD_HOME_CONTENT_FULFILLED:
      let imagesForScroller = [];

      if (action.payload.data["acf"]["imagescroller-1"] !== false) {
        imagesForScroller.push(
          action.payload.data["acf"]["imagescroller-1"].url
        );
      }

      if (action.payload.data["acf"]["imagescroller-2"] !== false) {
        imagesForScroller.push(
          action.payload.data["acf"]["imagescroller-2"].url
        );
      }

      if (action.payload.data["acf"]["imagescroller-3"] !== false) {
        imagesForScroller.push(
          action.payload.data["acf"]["imagescroller-3"]["url"]
        );
      }

      if (action.payload.data["acf"]["imagescroller-4"] !== false) {
        imagesForScroller.push(
          action.payload.data["acf"]["imagescroller-4"]["url"]
        );
      }

      if (action.payload.data["acf"]["imagescroller-5"] !== false) {
        imagesForScroller.push(
          action.payload.data["acf"]["imagescroller-5"]["url"]
        );
      }

      return {
        ...state,
        scrollerImages: imagesForScroller,
        loadingScrollerImages: false
      };
    case LOAD_HOME_SERVICES_FULFILLED:
      return {
        ...state,
        services: action.payload.data,
        loadingServices: false
      };
    case LOAD_HOME_REVIEW_FULFILLED:
      return {
        ...state,
        feedback: action.payload.data[0],
        loadingFeedback: false
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/home-reducer.js